import { ObjectFit } from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-object-fit.model';
import { AspectRatio } from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-aspect-ration.model';
import {
  CaptionOptions,
  CaptionPosition,
} from 'ag-common-svc/lib/components/administration/template-builder/template-editor-page/models/template-builder-caption.model';
import { Address } from '@ag-common-lib/lib/models/utils/address.model';

export enum MapType {
  default = 'default',
  satellite = 'satellite',
}

export const MAP_TYPE_LOOKUP = [
  { value: MapType.default, description: 'Default' },
  { value: MapType.satellite, description: 'Satellite' },
];

export class MapWidgetData {
  zoom: number = 12;
  center: Address;
  mapType?: MapType = MapType.default;
  gap: number = 8;
  width: number = 100;
  minWidth: number = 128;
  maxHeight: number;
  objectFit: ObjectFit = ObjectFit.cover;
  aspectRation: AspectRatio = AspectRatio.None;
  titleMode: CaptionPosition = CaptionPosition.none;
  titleOptions: CaptionOptions = new CaptionOptions();
  descriptionMode: CaptionPosition = CaptionPosition.none;
  descriptionOptions: CaptionOptions = new CaptionOptions(15);

  constructor() {
    this.center = new Address();
  }
}
